import labelApi from '@src/shared/components/reusables/labels/services/label-api';
import type { ChipValueRendererProps } from './chip-member-value';

export const ChipLabelValue = ({ id }: ChipValueRendererProps) => {
  const { data: label } = labelApi.useFetchOne({ id });

  return <>{label?.name}</>;
};
